import React from "react";
import { string } from "prop-types";

const Youtube = ({ color1 = "#121212" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28 28" width="28" height="28">
    <circle fill="#EEEEEE" cx="14" cy="14" r="13.5" />
    <path
      fill={color1}
      d="M21.715,10.225c-0.184-0.837-0.877-1.466-1.727-1.57C17.998,8.469,16,8.395,14.002,8.433
	c-1.997-0.038-3.995,0.036-5.984,0.221c-0.85,0.105-1.542,0.734-1.726,1.57c-0.233,1.245-0.326,2.512-0.279,3.777
	c-0.048,1.265,0.044,2.532,0.275,3.777c0.184,0.836,0.876,1.466,1.726,1.57c1.99,0.184,3.989,0.257,5.987,0.218
	c1.997,0.038,3.994-0.036,5.983-0.221c0.851-0.104,1.543-0.734,1.727-1.57c0.231-1.245,0.324-2.512,0.275-3.777
	C22.036,12.734,21.945,11.468,21.715,10.225z M11.939,16.481v-5.284l5.079,2.65L11.939,16.481z"
    />
  </svg>
);

Youtube.propTypes = {
  color1: string,
};

export default Youtube;
